import { twMerge } from "tailwind-merge";

import { Icon } from "shared/ui/icon";
import currencyPlaceholderSvg from "shared/ui/icon/svg/currency-placeholder.svg";
import { Img } from "shared/ui/img";

interface Props {
  disabled?: boolean;
  className?: string;
  icon?: string;
  symbol: string;
  onClick?: () => void;
}

export function Label(props: Props) {
  const { onClick, icon, symbol, disabled, className } = props;
  return (
    <div
      onClick={onClick}
      className={twMerge(
        "relative flex shrink-0 items-center space-x-1.5 rounded-[20px] text-xl text-bone",
        onClick &&
          "h-[29px] cursor-pointer  border border-white/20 pl-[5px] pr-[8px] hover:bg-white/3",
        disabled && "pointer-events-none cursor-default",
        className
      )}
    >
      <Img
        src={icon}
        className="size-5"
        fallbackUrl={currencyPlaceholderSvg}
        alt={symbol}
      />
      <span>{symbol}</span>
      {onClick && (
        <Icon
          name="caretDown"
          className="inline-flex size-3 shrink-0 text-bone opacity-50"
        />
      )}
    </div>
  );
}
